<!--微信登录授权界面-->
<template>
  <div>
  </div>
</template>

<script>
import { getAppID, login } from "../../../common/api/index";
import Vue from "vue";
import preventBack from "../../../common/forbidback";
import wxQrcode from '@/components/pi-wx-qrcode/pi-wx-qrcode.js'
export default {
  mixins: [preventBack], //注入禁止返回上一页
  components: {},
  data() {
    return {
      code: null,
      oprPkId: null,
      isCallback: false //是否是微信回调
    };
  },

  created() {
    this.isCallback = this.$common.isEmpty(this.$route.query.oprPkId);

    this.code = this.getCode();
    if (this.isCallback) {
      // 微信跳转回来，从state取出oprPkId
      this.oprPkId = this.$common.query("state");
    } else {
      this.oprPkId = this.$route.query.oprPkId;
    }

    if (this.isCallback) {
      this.$common.remove("goWxSecond");
      if (this.oprPkId) {
        this.doLogin();
      } else {
        this.$router.replace({
          name: "login",
          query: { oprPkId: this.$oprPkId,replace: true }
        });
      }
    } else {
      let goWxSecond = this.$common.get("goWxSecond") || 0;
      if(goWxSecond < 4){
        goWxSecond ++;
        this.$common.save("goWxSecond",goWxSecond)
        this.tryAuthorizedWeb();
      }else{
        this.$common.remove("goWxSecond");
        this.$dialog
          .alert({
            title: "获取微信信息异常，请重新登录",
            confirmButtonText: "确认",
            confirmButtonColor: "#14CC80"
          })
          .then(() => {});
      }
      
    }
  },
  computed: {},

  methods: {
    gotoTargetRouter() {
      this.$common.remove(this.$config.localKeyLogin.homeShowListStatus);
      this.$router.replace({ name: "home",replace: true });
    },
    doLogin() {
      let loginInfo = this.$common.get(this.$config.localKeyLogin.loginInfo);
      this.$common.remove(this.$config.localKeyLogin.loginInfo);
      let code = this.$common.query("code");
      // console.log(code);
      let loginParams = {
        code: code,
        oprPkId: this.oprPkId
      };
      if (loginInfo) {
        loginParams.phoneCode = loginInfo.phoneCode;
        loginParams.phoneNo = loginInfo.phone;
      }
      // console.log(loginParams) 
      login(loginParams)
        .then(data => {
          console.log(data);
          if (data.status === this.$config.ajaxStatus) {
            let loginData = data.data[0];
            if(loginData && loginData.hasSubscribe == 0){
                // 未关注公众号
              this.openWxQrcode(loginData.userPkId);
            }else{
              if (loginInfo || loginData.hasRegistered) {
                this.$common.save("token", loginData.accessToken);
                this.$common.save("userInfo", loginData);
                this.$common.save("oprPkId", this.oprPkId);
                this.$store.commit("SET_USERINFO", loginData);
                if (loginInfo) {
                  this.$common.save("phone", loginInfo.phone);
                }
                Vue.prototype.$oprPkId = this.oprPkId;
                this.gotoTargetRouter();
              } else {
                  this.$router.replace({
                    name: "login/bind",
                    query: {
                      userPkId: loginData.userPkId,
                      oprPkId: this.oprPkId,
                      replace: true
                    }
                  });
              }
            }
          } else {
            this.$router.replace({
              name: "login",
              query: { oprPkId: this.oprPkId,replace: true },
              params: { errorMsg: data.msg }
            });
          }
        })
        .catch(error => {
          console.log(error);
          this.$router.replace({
            name: "login",
            query: { oprPkId: this.oprPkId,replace: true },
            params: { errorMsg: "登录失败" }
          });
        });
    },
    tryAuthorizedWeb() {
      getAppID({
        oprPkId: this.oprPkId,
        appType: 1
      })
        .then(data => {
          if (data.status === this.$config.ajaxStatus) {
            let appId = data.data[0];
            let redirectUri = encodeURIComponent(
              window.location.href
                .replace(window.location.search, "")
                .replace(window.location.hash, "")
            );
            if (
              window.location.href.indexOf(":808") == -1 &&
              window.location.href.indexOf("http://10.0.110.86") == -1 &&
              window.location.href.indexOf("http://192.168") == -1
            ) {
              let authorizeUri = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=${this.oprPkId}#wechat_redirect`;
              window.location.replace(authorizeUri);
            } else {
              // 本地
              let codeUrl =
                this.$config.codeUrl ||
                "http://smartpiems.pmac.com.cn/getcode/get-code.html";
                // console.log(`${codeUrl}?appId=${appId}&oprPkId=${this.oprPkId}&url=${redirectUri}`)
              window.location.href = `${codeUrl}?appId=${appId}&oprPkId=${this.oprPkId}&url=${redirectUri}`;
            }
          } else {
            this.$router.replace({
              name: "login",
              query: { oprPkId: this.oprPkId,replace: true },
              params: { errorMsg: data.msg }
            });
          }
        })
        .catch(error => {
          console.log(error);
          this.$router.replace({
            name: "login",
            query: { oprPkId: this.oprPkId,replace: true },
            params: { errorMsg: "获取appid失败" }
          });
        });
    },
    openWxQrcode(userPkId){
      wxQrcode({oprPkId :this.oprPkId,userPkId: userPkId});
    },
    /**
     * 从url参数获取code
     */
    getCode() {
      var url = location.search; //获取url中"?"符后的字串 ('?modFlag=business&role=1')
      var theRequest = {};
      if (url.indexOf("?") !== -1) {
        var str = url.substr(1); //substr()方法返回从参数值开始到结束的字符串；
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
        console.log(theRequest); //此时的theRequest就是我们需要的参数；
      }
      return theRequest.code;
    }
  }
};
</script>

<style scoped>
</style>
<style>
</style>
